function MainApp() {
    return {
        menuCollapsed: false,
        navbarEl: null,
        navbarToggleEl: null,
        navbarMobileMenuEl: null,
        activeTeamCard: null,

        init() {
            if (this.$refs.navbar) this.navbarEl = this.$refs.navbar;
            if (this.$refs.navbarToggle) this.navbarToggleEl = this.$refs.navbarToggle;
            if (this.$refs.navbarMobileMenu) this.navbarMobileMenuEl = this.$refs.navbarMobileMenu;

            this.$watch("menuCollapsed", (state) => {
                if (state) document.documentElement.style.overflow = "hidden";
                else document.documentElement.style.overflow = "auto";
            })

            this.$watch("activeTeamCard", (state) => {
                if (state) document.documentElement.style.overflow = "hidden";
                else document.documentElement.style.overflow = "auto";
            })
        },
    
        toggleMenu() {
            this.navbarEl.classList.toggle("is-collapsed");
            this.menuCollapsed = !this.menuCollapsed;
        },

        openTeam(activeIndex) {
            this.activeTeamCard = activeIndex
        },

        closeTeam() {
            this.activeTeamCard = null
        }
    }
}

const InitialiseComponent = async () => {
    const lists = {
        "MainApp": MainApp
    };

    Object.keys(lists).forEach(fn => window[fn] = lists[fn])
}

export { InitialiseComponent }